//import 'animate.css';
// import 'video.js';
// import 'video.js/dist/video-js.css';

// import Rellax from 'rellax';
// var rellax = new Rellax('.rellax');

// window.onload = function() {
//     var rellax = new Rellax('.rellax');
//     rellax.refresh();
// }


import Impact from './impact';
import Icons from './icons';
import Header from './header';
import HorizontalGraph from './what-we-do';
import Supporters from './supporters';
import Mapslider from './mapslider';
import Conflicts from './emerging-conflicts';
import Programs from './programs';
import Injustice from './injustice';
import Locally from './locally';
import NotOk from './not-ok';
import Changes from './changes';
import BreakingIsolation from './breaking-isolation';
import InAction from './in-action';

new InAction();

new BreakingIsolation();
new Changes();
new NotOk();
new Locally();
new Programs();
new Conflicts();
new Supporters();
new HorizontalGraph();
new Icons();
new Header();
new Impact();
new Mapslider();
new Injustice();

const lightbox = GLightbox({
    selector: '.glightbox',
    touchNavigation: true,
    loop: true,
    autoplayVideos: true
});



// const player = new Plyr('.player');